import { render, staticRenderFns } from "./SearchClients.vue?vue&type=template&id=0039ac0c&scoped=true&"
import script from "./SearchClients.vue?vue&type=script&lang=js&"
export * from "./SearchClients.vue?vue&type=script&lang=js&"
import style0 from "./SearchClients.vue?vue&type=style&index=0&id=0039ac0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0039ac0c",
  null
  
)

export default component.exports